import Vue from 'vue'
import VueSignature from "vue-signature-pad";
import App from './App.vue'
import router from '@/router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { VueSpinners } from '@saeris/vue-spinners'
import "@/assets/css/tailwind.css"

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSignature);
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueSpinners)
Vue.use(VueSweetalert2)

new Vue({
  router: router,
  render: h => h(App),
}).$mount('#app')